import React from "react";

export function CategoryFormatter(cellContent, row){
    return (
        <>
            {row.productCategory[0].name}
        </>
    )
}